import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { SignaturePad } from "angular2-signaturepad/signature-pad";

@Component({
  selector: 'page-signature',
  templateUrl: 'signature.html',
})
export class SignaturePage {

  isDrawing = false;

  form: FormGroup;
  field: '';

  @ViewChild('signaturepad') signaturePad: SignaturePad;

  signaturePadOptions = { // Check out https://github.com/szimek/signature_pad
    'minWidth': 2,
    'canvasWidth': 600,
    'canvasHeight': 430,
    'backgroundColor': '#F1F1F1',
    'penColor': '#000000'
  };

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public viewCtrl: ViewController
  ) {
    this.form = navParams.get('form');
    this.field = navParams.get('field');
  }

  clearPad(){
    this.signaturePad.clear();
  }

  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SignaturePage');
  }

  save() {
    this.form.get(this.field).setValue(this.signaturePad.toDataURL());
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/signature/signature.ts